

import hSeriesImg from "../assets/images//vehicles/h-series/h-series-main-trans.png";
import ehSeriesImg from "../assets/images/vehicle-2-card-banner.png";
import dumperImg from "../assets/images/vehicle-3-card-banner.png";

// H-Series IMAGES STARTS

import lkcs5WhiteImage from "../assets/images/vehicles/h-series/h-series-white-trans.png";
import lkcs5RedImage from "../assets/images/vehicles/h-series/h-series-red-trans.png";
import lkcs5BlueImage from "../assets/images/vehicles/h-series/h-series-blue-trans.png";


// H-Series IMAGES ENDS

// H-Series BROCHURE STARTS

import hSeriesBrochure from "../assets/images/vehicles/h-series/brochure/landking-h-series-brochure.pdf"

// H-SERIES BROCHURE ENDS

// VEHICLE INTRO BANNER STARTS

import lkCS5Banner from "../assets/images/h-series-mark-banner.png";

// VEHICLE INTRO BANNER ENDS

// VEHICLE FEATURES IMAGE STARTS


import lkFeatureComfort from "../assets/images/vehicles/lk-cs5/feature.png";
import hSeriesFeature2 from "../assets/images/vehicles/h-series/features/features-2.png";
import hSeriesFeature3 from "../assets/images/vehicles/h-series/features/feature-3.png";
import hSeriesFeature4 from "../assets/images/vehicles/h-series/features/feature-4.png";
import hSeriesFeature5 from "../assets/images/vehicles/h-series/features/features-5.png"

// VEHICLE FEATURES IMAGE ENDS


// VEHICLE TECH SECTION STARTS

import hSeriesTech1 from "../assets/images/vehicles/h-series/technology/technology-1.png";
import hSeriesTech2 from "../assets/images/vehicles/h-series/technology/technology-2.png";


// VEHICLE TECH SECTION ENDS// 


// VEHICLE INTERIOR SECTION STARTS //

import hSeriesInterior1 from "../assets/images/vehicles/h-series/interiors/interiors-1.png";
import hSeriesInterior2 from "../assets/images/vehicles/h-series/interiors/interiors-2.png";
import hSeriesInterior3 from "../assets/images/vehicles/h-series/interiors/interiors-3.png";
import hSeriesInterior4 from "../assets/images/vehicles/h-series/interiors/interiors-4.png";
import hSeriesInterior5 from "../assets/images/vehicles/h-series/interiors/interiors-5.png";
import hSeriesInterior6 from "../assets/images/vehicles/h-series/interiors/interiors-6.png";


// VEHICLE INTERIOR SECTION ENDS //

const vehiclesData = [
  {
    id: "veh-h-series",
    brand: "LandKing",
    modelName: "H-Series",
    title: "LandKing H-Series",
    imageSrc: hSeriesImg,
    href: "/vehicles/h-series",
    background: "#1E8BCB",
    shortDescription: "The LANDKING H-Series is built to challenge the status quo of commercial trucking. Engineered for Saudi roads and relentless workloads, it delivers raw power, proven endurance, and uncompromising reliability without inflated costs.",
    price: "SAR 80,000",
    // engine: "2.3L - 3.0L",
    // payload: "4TONS - 6TONS",
    // hpTorque: "320 HP / 1,250 Nm",
    detailIntroBanner: lkCS5Banner,
    detailIntroTitle: "Built for Saudi Roads. Tuned for Your Business.",
    detailIntroParagraph1:
      "The LANDKING H-Series is engineered beyond expectation, where performance meets purpose. Designed for the unforgiving roads of Saudi Arabia, every H-Series truck delivers relentless power, uncompromising durability, and total control under pressure. Where others slow down, struggle, or settle, the H-Series pushes forward without hesitation.",
    detailIntroParagraph2:
      "This is the truck for businesses that refuse to compromise on performance, on reliability, or on cost. While competitors charge more and promise less, the H-Series proves itself where it matters most: on the road, under load, day after day. This isn’t just heavy-duty trucking, it’s dependable performance engineered for businesses that measure success by results.",
    variants: [
      {
        id: "h60s",
        name: "H-60S",
        priceLabel: "SAR 80,000*",
        brochureUrl: hSeriesBrochure,
        hpTorque: "140 HP / 320 Nm",
        payload:"4,005KG",
        engine:"2.3L"
      },
      {
        id: "h60l",
        name: "H-60L",
        priceLabel: "SAR 82,000*",
        brochureUrl: hSeriesBrochure,
        hpTorque: "140 HP / 320 Nm",
        payload:"3,835KG",
        engine:"2.3L"
      },
      {
        id: "h75s",
        name: "H-75S",
        priceLabel: "SAR 89,900*",
        brochureUrl: hSeriesBrochure,
        hpTorque: "160 HP / 480 Nm",
        payload:"5,100KG",
        engine:"3.0L"
      },
      {
        id: "h75L",
        name: "H-75L",
        priceLabel: "SAR 91,900*",
        brochureUrl: hSeriesBrochure,
        hpTorque: "160 HP / 480 Nm",
        payload:"5,100KG",
        engine:"3.0L"
      },
      {
        id: "h95s",
        name: "H-95S",
        priceLabel: "SAR 103,000*",
        brochureUrl: hSeriesBrochure,
        hpTorque: "160 HP / 480 Nm",
        payload:"6,550KG",
        engine:"3.0L"
      },
      {
        id: "h95l",
        name: "H-95L",
        priceLabel: "SAR 105,000*",
        brochureUrl: hSeriesBrochure,
        hpTorque: "160 HP / 480 Nm",
        payload:"6,500KG",
        engine:"3.0L"
      }
    ],

    colors: [
      {
        id: "white",
        name: "Arctic White",
        colorCode: "#f5f5f5",
        imageSrc: lkcs5WhiteImage
      },
      {
        id: "red",
        name: "Crimson Red",
        colorCode: "#b12028",
        imageSrc: lkcs5RedImage
      },
      {
        id: "blue",
        name: "Midnight Blue",
        colorCode: "#1e3a8a",
        imageSrc: lkcs5BlueImage
      }
    ],

    featureSlides: [
      {
        id: "hSerires-power",
        imageSrc: lkFeatureComfort,
        title: "Relentless Powertrain",
        description:
          "High-torque diesel engine tuned for steep gradients and full-load performance across Saudi routes."
      },
      {
        id: "hSeries-Feature-2",
        imageSrc: hSeriesFeature2,
        title: "Driver-First Cabin",
        description:
          "Ergonomic seats, reduced NVH, and smart storage to keep drivers focused and fatigue-free."
      },
      {
        id: "hSeries-Feature-3",
        imageSrc: hSeriesFeature3,
        title: "Engineered for Total Control",
        description:
          "Integrated steering-mounted controls give you seamless access to key functions with features such as Cruise Control."
      },
      {
        id: "hSeries-Feature-4",
        imageSrc: hSeriesFeature4,
        title: "Control Where It Matters Most",
        description:
          "Intuitive climate and safety controls are designed to keep the driver comfortable, focused, and in complete control at all times."
      },
      {
        id: "hSeries-Feature-5",
        imageSrc: hSeriesFeature5,
        title: "12.3-Inch Display with Rear View Camera",
        description:
          "A large 12.3-inch touchscreen display with integrated rear view camera provides clear visuals and precise guidance for safer, more confident maneuvering."
      }
    ],

    technologySlides: [
      {
        id: "hSeries-tech-1",
        title: "Smart Intelligence that Commands the Road",
        paragraph1:
          "The LANDKING H-Series instrument cluster is not just designed to impress, it is designed to inform, alert, and dominate. Every gauge, indicator, and digital readout is engineered to deliver real-time intelligence with absolute clarity, giving the driver complete awareness of performance, efficiency, and system health at every moment.",
        paragraph2:
          "While others rely on basic displays and delayed feedback, the H-Series puts data where it belongs directly in the driver’s line of command. This is not just a dashboard; it is a control interface built for those who operate under pressure, carry heavy responsibility, and refuse to drive blind. When the road challenges you, this cluster ensures you’re always one step ahead.",
        imageSrc: hSeriesTech1
      },
      {
        id: "hSeries-tech-2",
        title: "Technology That Works as Hard as You Do",
        paragraph1:
          "The LANDKING H-Series infotainment system is built for drivers who demand more than basic connectivity. With a clear, responsive interface and intuitive controls, it puts communication, media, and essential functions exactly where they’re needed front and center. Every interaction is smooth, deliberate, and engineered to minimize distraction while maximizing control.",
        paragraph2:
          "While competitors treat infotainment as an afterthought, the H-Series makes it a command tool. Designed for real-world operations and long hours on the road, this system delivers clarity under pressure and confidence in motion. It’s not about flashy screens or gimmicks—it’s about technology that keeps up with the job and stays ahead of the challenge.",
        imageSrc: hSeriesTech2
      }
    ],

    interiors: [
      {
        id: "hSeries-int-1",
        imageSrc: hSeriesInterior1,
        title: "Total Command in your Hands",
        description:
          "A modern, ergonomic steering wheel that delivers precise handling, premium feel, and complete confidence on every drive."
      },
      {
        id: "hSeries-int-2",
        imageSrc: hSeriesInterior2,
        title: "Modern Cabin made to lead",
        description:
          "A spacious, driver-focused cabin designed to deliver comfort, clarity, and total control through every mile and every challenge."
      },
      {
        id: "hSeries-int-3",
        imageSrc: hSeriesInterior3,
        title: "Smooth & Effortless Shifts",
        description:
          "A precision-engineered gear lever designed for smooth, easy shifts and confident control throughout long and demanding drives."
      },
      {
        id: "hSeries-int-4",
        imageSrc: hSeriesInterior4,
        title: "Premium Touch Built to Last",
        description:
          "Carefully finished leather trim and solid door handles add a refined, premium feel to the cabin while maintaining the durability demanded by everyday commercial use."
      },
      {
        id: "hSeries-int-5",
        imageSrc: hSeriesInterior5,
        title: "Cabin Around Driver",
        description:
          "From its intuitive dashboard layout to thoughtfully placed controls and premium materials, the LANDKING H-Series cabin delivers comfort, clarity, and control from every angle."
      },
      {
        id: "hSeries-int-6",
        imageSrc: hSeriesInterior6,
        title: "Control at Your Fingertips",
        description:
          "Precisely placed automatic window controls deliver smooth operation and solid feedback, reinforcing the LANDKING H-Series focus on everyday comfort with commercial-grade durability."
      }
    ],

    spareParts: [
      {
        variantId: "h-60-SpareParts",
        variantName: "H60",
        parts: [
          {
            id: "hSeries-std-part-1",
            descriptionEn: "Engine Oil",
            price: "SAR 21.85",
            descriptionAr: "زيت محرك"
          },
          {
            id: "hSeries-std-part-2",
            descriptionEn: "Engine Oil Filter",
            price: "SAR 78.20",
            descriptionAr: "فلتر زيت المحرك"
          },
          {
            id: "hSeries-std-part-3",
            descriptionEn: "Fuel Filter",
            price: "SAR 89.70",
            descriptionAr: "فلتر الوقود"
          },
          {
            id: "hSeries-std-part-4",
            descriptionEn: "Air Filter",
            price: "SAR 224.25",
            descriptionAr: "فلتر الهواء"
          },
          {
            id: "hSeries-std-part-5",
            descriptionEn: "Brake Shoe Front",
            price: "SAR 458.85",
            descriptionAr: "فحمات فرامل أمامية"
          },
          {
            id: "hSeries-std-part-6",
            descriptionEn: "Brake Shoe Rear",
            price: "SAR 548.55",
            descriptionAr: "فحمات فرامل خلفية"
          }
        ]
      },
      {
        variantId: "h-75-SpareParts",
        variantName: "H75",
        parts: [
          {
            id: "hSeries-std-part-1",
            descriptionEn: "Engine Oil",
            price: "SAR 21.85",
            descriptionAr: "زيت محرك"
          },
          {
            id: "hSeries-std-part-2",
            descriptionEn: "Engine Oil Filter",
            price: "SAR 78.20",
            descriptionAr: "فلتر زيت المحرك"
          },
          {
            id: "hSeries-std-part-3",
            descriptionEn: "Fuel Filter",
            price: "SAR 166.75",
            descriptionAr: "فلتر الوقود"
          },
          {
            id: "hSeries-std-part-4",
            descriptionEn: "Air Filter",
            price: "SAR 224.25",
            descriptionAr: "فلتر الهواء"
          },
          {
            id: "hSeries-std-part-5",
            descriptionEn: "Brake Shoe Front",
            price: "SAR 458.85",
            descriptionAr: "فحمات فرامل أمامية"
          },
          {
            id: "hSeries-std-part-6",
            descriptionEn: "Brake Shoe Rear",
            price: "SAR 548.55",
            descriptionAr: "فحمات فرامل خلفية"
          }
        ]
      },
      {
        variantId: "h-95-SpareParts",
        variantName: "H95",
        parts: [
          {
            id: "hSeries-std-part-1",
            descriptionEn: "Engine Oil",
            price: "SAR 21.85",
            descriptionAr: "زيت محرك"
          },
          {
            id: "hSeries-std-part-2",
            descriptionEn: "Engine Oil Filter",
            price: "SAR 78.20",
            descriptionAr: "فلتر زيت المحرك"
          },
          {
            id: "hSeries-std-part-3",
            descriptionEn: "Fuel Filter",
            price: "SAR 166.75",
            descriptionAr: "فلتر الوقود"
          },
          {
            id: "hSeries-std-part-4",
            descriptionEn: "Air Filter",
            price: "SAR 224.25",
            descriptionAr: "فلتر الهواء"
          },
          {
            id: "hSeries-std-part-5",
            descriptionEn: "Brake Shoe Front",
            price: "SAR 458.85",
            descriptionAr: "فحمات فرامل أمامية"
          },
          {
            id: "hSeries-std-part-6",
            descriptionEn: "Brake Shoe Rear",
            price: "SAR 548.55",
            descriptionAr: "فحمات فرامل خلفية"
          }
        ]
      }
    ],

    specVariants: [
      { id: "h60s", name: "H-60S" },
      { id: "h60l", name: "H-60L" },
      { id: "h75s", name: "H-75S" },
      { id: "h75l", name: "H-75L" },
      { id: "h95s", name: "H-95S" },
      { id: "h95l", name: "H-95L" },
    ],

    specifications: [
      {
        id: "dimensions",
        title: "Dimensions",
        rows: [
          {
            label: "Wheelbase (mm)",
            values: { h60s: "3300", h60l: "3800", h75s: "3800", h75l: "4200", h95s: "4200", h95l: "4500" }
          },
          {
            label: "Overall Dimensions (mm)",
            values: { h60s: "6125*2145*2310", h60l: "6780*2145*2330", h75s: "6780*2150*2330", h75l: "7425*2145*2330", h95s: "7395*2185*2340", h95l: "7887*2185*2340" }
          },
          {
            label: "Overall Length (OAL)",
            values: { h60s: "6125", h60l: "6780", h75s: "6780", h75l: "7425", h95s: "7395", h95l: "7887" }
          },
          {
            label: "Front Overhang (FOH)",
            values: { h60s: "1130", h60l: "1130", h75s: "1130", h75l: "1130", h95s: "1130", h95l: "1130" }
          },
          {
            label: "Rear Overhang (ROH)",
            values: { h60s: "1695", h60l: "1850", h75s: "1755", h75l: "2005", h95s: "1975", h95l: "2257" }
          },
          {
            label: "Cable to Axle (CA)",
            values: { h60s: "2765", h60l: "3265", h75s: "3265", h75l: "3665", h95s: "3665", h95l: "3965" }
          },
          {
            label: "Cable to End (CE)",
            values: { h60s: "4460", h60l: "5020", h75s: "5020", h75l: "5670", h95s: "5670", h95l: "6130" }
          }
        ]
      },
      {
        id: "weight-capacity",
        title: "Weight & Capacity",
        rows: [
          {
            label: "Gross Vehicle Weight (GVW) (kg)",
            values: { h60s: "6500", h60l: "6500", h75s: "8000", h75l: "8000", h95s: "9500", h95l: "9500" }
          },
          {
            label: "Curb Weight (kg)",
            values: { h60s: "2495", h60l: "2665", h75s: "2900", h75l: "2900", h95s: "2950", h95l: "3000" }
          },
          {
            label: "Payload (kg)",
            values: { h60s: "4005", h60l: "3835", h75s: "5100", h75l: "5100", h95s: "6550", h95l: "6500" }
          },
          {
            label: "Fuel Tank Capacity",
            values: { h60s: "150L", h60l: "150L", h75s: "200L", h75l: "200L", h95s: "200L", h95l: "200L" }
          },
          {
            label: "Fuel Tank Material",
            values: { h60s: "Aluminium Alloy", h60l: "Aluminium Alloy", h75s: "Aluminium Alloy", h75l: "Aluminium Alloy", h95s: "Aluminium Alloy", h95l: "Aluminium Alloy" }
          }
        ]
      },
      {
        id: "powertrain",
        title: "Engine / Power Battery",
        rows: [
          {
            label: "Brand/Model",
            values: { h60s: "WP2.3Q140E50", h60l: "WP2.3Q140E50", h75s: "WP3NQ160E50", h75l: "WP3NQ160E50", h95s: "WP3NQ160E50", h95l: "WP3NQ160E50" }
          },
          {
            label: "Rated Power",
            values: { h60s: "C6J40T-B", h60l: "C6J40T-B", h75s: "C6J50T", h75l: "C6J50T", h95s: "C6J50T", h95l: "C6J50T" }
          }
        ]
      },
      {
        id: "axle-system",
        title: "Axle System",
        rows: [
          {
            label: "Front Axle (Brand / Tonnage / Brake Type)",
            values: { h60s: "3.0T HanDe Maintenance-Free Front Axle", h60l: "3.0T HanDe Maintenance-Free Front Axle", h75s: "3.0T HanDe Maintenance-Free Front Axle", h75l: "3.0T HanDe Maintenance-Free Front Axle", h95s: "3.0T HanDe Maintenance-Free Front Axle", h95l: "3.0T HanDe Maintenance-Free Front Axle" }
          },
          {
            label: "Rear Axle (Brand / Tonnage / Gear Ratio)",
            values: { h60s: "Rated Load 5.0T/4.875 Hande Rear Axle", h60l: "Rated Load 5.0T/4.875 Hande Rear Axle", h75s: "5T/4.333 Hande Rear Axle", h75l: "5T/4.333 Hande Rear Axle", h95s: "Rated Load 6T/4.333 Hande Rear Axle", h95l: "Rated Load 6T/4.333 Hande Rear Axle" }
          }
        ]
      },
      {
        id: "frame-chassis",
        title: "Frame & Chassis",
        rows: [
          {
            label: "Frame Dimensions (mm)",
            values: { h60s: "180/800", h60l: "180/800", h75s: "215/800", h75l: "215/800", h95s: "215/800", h95l: "215/800" }
          },
          {
            label: "Suspension Type",
            values: { h60s: "3/5+2", h60l: "3/5+2", h75s: "3/8+6", h75l: "3/8+6", h95s: "3/8+6", h95l: "3/8+6" }
          }
        ]
      },
      {
        id: "wheels-brakes",
        title: "Wheels & Braking System",
        rows: [
          {
            label: "Tyre Type",
            values: { h60s: "215/75R17.5 16PR", h60l: "215/75R17.5 16PR", h75s: "215/75R17.5 16PR", h75l: "215/75R17.5 16PR", h95s: "215/75R17.5 16PR", h95l: "215/75R17.5 16PR" }
          },
          {
            label: "Spare Tyre",
            values: { h60s: "Yes", h60l: "Yes", h75s: "Yes", h75l: "Yes", h95s: "Yes", h95l: "Yes" }
          },
          {
            label: "Service Brake Type",
            values: { h60s: "Pneumatic Brake", h60l: "Pneumatic Brake", h75s: "Pneumatic Brake", h75l: "Pneumatic Brake", h95s: "Pneumatic Brake", h95l: "Pneumatic Brake" }
          },
          {
            label: "ABS/AEB/ESC",
            values: { h60s: "ABS+ASR", h60l: "ABS+ASR", h75s: "ABS+ASR", h75l: "ABS+ASR", h95s: "ABS+ASR", h95l: "ABS+ASR" }
          },
          {
            label: "Exhaust Auxiliary Brake",
            values: { h60s: "Yes", h60l: "Yes", h75s: "Yes", h75l: "Yes", h95s: "Yes", h95l: "Yes" }
          }
        ]
      },
      {
        id: "interior-features",
        title: "Interiors & Features",
        rows: [
          {
            label: "Air Conditioner",
            values: { h60s: "Yes", h60l: "Yes", h75s: "Yes", h75l: "Yes", h95s: "Yes", h95l: "Yes" }
          },
          {
            label: "Air Horns",
            values: { h60s: "Yes", h60l: "Yes", h75s: "Yes", h75l: "Yes", h95s: "Yes", h95l: "Yes" }
          },
          {
            label: "Multimedia System",
            values: { h60s: "MP5+Reversing Image", h60l: "MP5+Reversing Image", h75s: "MP5+Reversing Image", h75l: "MP5+Reversing Image", h95s: "MP5+Reversing Image", h95l: "MP5+Reversing Image" }
          },
          {
            label: "Steering Wheel",
            values: { h60s: "Multifunction Steering Wheel with Cruise Control", h60l: "Multifunction Steering Wheel with Cruise Control", h75s: "Multifunction Steering Wheel with Cruise Control", h75l: "Multifunction Steering Wheel with Cruise Control", h95s: "Multifunction Steering Wheel with Cruise Control", h95l: "Multifunction Steering Wheel with Cruise Control" }
          },
          {
            label: "Central Lock + Electric Doors & Windows",
            values: { h60s: "Yes", h60l: "Yes", h75s: "Yes", h75l: "Yes", h95s: "Yes", h95l: "Yes" }
          },
          {
            label: "Rear View Mirror",
            values: { h60s: "Ordinary Rearview Mirror", h60l: "Ordinary Rearview Mirror", h75s: "Ordinary Rearview Mirror", h75l: "Ordinary Rearview Mirror", h95s: "Ordinary Rearview Mirror", h95l: "Ordinary Rearview Mirror" }
          },
          {
            label: "Interior Trim & Finish",
            values: { h60s: "Red & Black", h60l: "Red & Black", h75s: "Red & Black", h75l: "Red & Black", h95s: "Red & Black", h95l: "Red & Black" }
          },
        ]
      },
      {
        id: "exterior-features",
        title: "Exterior & Features",
        rows: [
          {
            label: "Headlights",
            values: { h60s: "LED DRLs/LED Headlights", h60l: "LED DRLs/LED Headlights", h75s: "LED DRLs/LED Headlights", h75l: "LED DRLs/LED Headlights", h95s: "LED DRLs/LED Headlights", h95l: "LED DRLs/LED Headlights" }
          },
          {
            label: "Front Fog Lights",
            values: { h60s: "Yes", h60l: "Yes", h75s: "Yes", h75l: "Yes", h95s: "Yes", h95l: "Yes" }
          },
        ]
      }
    ],

    servicePackages: {
      variants: ["H60", "H75", "H95"],
      mileageOptions: ["5000km", "20,000km", "40,000km", "60,000km", "80,000km", "100,000km"],

      prices: {
        H60: {
          // "5000km": "SAR 442.75",
          "5000km":"Free",
          "20,000km": "SAR 722.20",
          "40,000km": "SAR 1,118.95",
          "60,000km": "SAR 933.34",
          "80,000km": "SAR 1,118.95",
          "100,000km": "SAR 1,088.82"
        },
        H75: {
          // "5000km": "SAR 453.68",
          "5000km":"Free",
          "20,000km": "SAR 810.18",
          "40,000km": "SAR 1,206.93",
          "60,000km": "SAR 1,030.98",
          "80,000km": "SAR 1,206.93",
          "100,000km": "SAR 1,242.58"
        },
        H95: {
          // "5000km": "SAR 453.68",
          "5000km":"Free",
          "20,000km": "SAR 810.18",
          "40,000km": "SAR 1,026.93",
          "60,000km": "SAR 1,030.98",
          "80,000km": "SAR 1,206.93",
          "100,000km": "SAR 1,242.58"
        }
      }
    }
  },

  // {
  //   id: "veh-ev-series",
  //   title: "EH-Series Electric",
  //   imageSrc: ehSeriesImg,
  //   href: "/trucks/eh-series",
  //   background: "#3C2A98",
  //   shortDescription: "While others struggle in city heat and narrow turns, the LK5 laughs in the face of limits. Small in footprint. Giant in attitude.",
  //   price: "SAR 58,000",
  //   engine: "5.0L",
  //   payload: "2.5TONS"
  // },

  // {
  //   id: "veh-dumper",
  //   title: "Heavy Duty Dumper",
  //   imageSrc: dumperImg,
  //   href: "/trucks/dumpers",
  //   background: "#3F3F3F",
  //   shortDescription: "While others struggle in city heat and narrow turns, the LK5 laughs in the face of limits. Small in footprint. Giant in attitude.",
  //   price: "SAR 58,000",
  //   engine: "5.0L",
  //   payload: "2.5TONS"
  // },

  // {
  //   id: "veh-ev-series",
  //   title: "EH-Series Electric",
  //   imageSrc: ehSeriesImg,
  //   href: "/trucks/eh-series",
  //   background: "#3C2A98",
  //   shortDescription: "While others struggle in city heat and narrow turns, the LK5 laughs in the face of limits. Small in footprint. Giant in attitude.",
  //   price: "SAR 58,000",
  //   engine: "5.0L",
  //   payload: "2.5TONS"
  // }
];

export default vehiclesData;
